export enum CauseAreaMetricsShowBy {
  values,
  count,
  impact,
}
